import { validateValueIsDefined } from '../../common/reduxFormValidation';

const validateDateAndTransportType = (fee, errorMap, feeFieldName) => {
  validateValueIsDefined(fee, 'date', feeFieldName, errorMap);
  validateValueIsDefined(fee, 'transportType', feeFieldName, errorMap);
};

export default validateDateAndTransportType;
